export default __webpack_public_path__ + "static/media/organisation-active.791a7a51.svg";